module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa003.2ae331bd.png";